module.exports = __webpack_public_path__ + "static/media/collision-cover.8a1bd082.jpg";